import angular from 'angular';

import bulkSelect from './bulk-select.component';

export default angular.module('bulk-select', [
])
	.component('bulkSelect', bulkSelect)
	.name;
